import { EventEmitter, OnDestroy, OnInit, Directive } from '@angular/core';
import { PaymentFormService } from '../payment-form.service';
import { BehaviorSubject } from 'rxjs';
import { PaymentFormData } from '../payment-form.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PAYMENT_TYPES } from 'services/payment/payment.interface';
import { DEFAULT_CARD_FORM_DATA_VALUE, HolderNameData, FORM_PLACEHOLDERS } from '../payment-form.constants';
import _cloneDeep from 'lodash-es/cloneDeep';
import _mapValues from 'lodash-es/mapValues';
import _every from 'lodash-es/every';

import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@UntilDestroy()
@Directive()
export abstract class PaymentCardCommonFormComponent implements OnInit, OnDestroy {
  showError = false;
  formChange = new EventEmitter<any>();

  FORM_PLACEHOLDERS = FORM_PLACEHOLDERS;
  cardForm: UntypedFormGroup;

  paymentType: PAYMENT_TYPES;

  holderNameFormData$ = new BehaviorSubject<PaymentFormData<string>>(new HolderNameData(''));
  cardFormData$ = new BehaviorSubject<PaymentFormData<any>>(_cloneDeep(DEFAULT_CARD_FORM_DATA_VALUE));

  constructor(private paymentService: PaymentFormService) {}

  ngOnInit() {
    this.paymentService
      .subscribeOnFormChanges(this.holderNameFormData$, this.cardFormData$, this.paymentType)
      .pipe(untilDestroyed(this))
      .subscribe((data) => this.formChange.emit(data));

    this.initPaymentForm();
  }

  ngOnDestroy() {}

  private initPaymentForm() {
    this.cardForm = new UntypedFormGroup({
      cardNumber: new UntypedFormControl(''),
      cvv: new UntypedFormControl(''),
      expDate: new UntypedFormControl(''),
      holderName: new UntypedFormControl(''),
    });

    this.cardForm.valueChanges.pipe(untilDestroyed(this)).subscribe((values) => {
      const { holderName, mappedCardValues } = this.mapCardValues(values);
      this.cardFormData$.next({
        value: mappedCardValues,
        valid: _every(mappedCardValues, (value) => !!value),
        errorMessage: '',
      });
      this.holderNameFormData$.next(new HolderNameData(holderName));
    });
  }

  mapCardValues(values) {
    const { holderName, ...cardValues } = values;
    const mappedCardValues = _mapValues(cardValues, (value) => value.replace(/[^\d]/g, ''));
    return { holderName, mappedCardValues };
  }
}
